<template>
  <header :class="{'fixed top-0 left-0': sticky}" class="w-full z-40">
    <div
      class="bg-white flex items-center justify-between py-3 px-4 lg:p-[24px] lg:rounded-[24px] lg:mt-[30px] lg:max-w-[1330px] lg:mx-auto"
      :class="{'border border-[#FBD200]': variant === 'light'}"
    >
      <div class="flex items-center gap-x-[18px]">
        <IconsBurger class="lg:hidden cursor-pointer" @click="menuVisible = true" />
        <NuxtLink :to="localePath('/')"><IconsLogo class="hidden md:block"/></NuxtLink>
        <NuxtLink :to="localePath('/')"><IconsLogoSmall class="md:hidden"/></NuxtLink>
      </div>
      <div class="hidden lg:block">
        <Menu v-model="menuVisible" />
      </div>
      <div class="flex items-center gap-7">
        <div class="flex items-center gap-x-[18px]">
          <LanguageSwitcher />
          <nuxt-link :to="localePath('/cabinet/auth/sign-in')" class="font-nutino text-[14px] hover:underline">{{ t('b2b.header.login') }}</nuxt-link>
        </div>
        <div class="hidden md:block">
          <Btn :to="localePath({path: '/', hash: '#feedback'})" :tag="NuxtLink" small>{{ t('b2b.header.button') }}</Btn>
        </div>
      </div>
    </div>
    <MenuMobile v-model="menuVisible"/>
  </header>
</template>

<script setup lang="ts">
import IconsLogo from "~/components/icons/Logo.vue";
import IconsLogoSmall from "~/components/icons/LogoSmall.vue";
import IconsBurger from "~/components/icons/Burger.vue";
import LanguageSwitcher from "~/components/ui/LanguageSwitcher.vue";
import Btn from "~/components/ui/Btn.vue";
import Menu from "~/components/ui/Menu.vue";
import MenuMobile from "~/components/ui/MenuMobile.vue";
import {NuxtLink} from "#components";
import { useWindowScroll, useScrollLock } from '@vueuse/core'

const { t } = useI18n();
const router = useRouter();
const localePath = useLocalePath();

type TVariant = 'dark' | 'light';

interface Props {
  sticky?: boolean
  variant?: TVariant
}

withDefaults(defineProps<Props>(), {
  sticky: true,
  variant: 'dark'
})

const menuVisible = ref(false)

const { x, y } = useWindowScroll()
const isLocked = useScrollLock(document)
watch(menuVisible, val => {
  if (val) {
    y.value = 0;
    isLocked.value = true;
  } else {
    isLocked.value = false;
  }
})
</script>

